import { combineReducers } from "redux";
import {
  CRON_LOG_VIEW
} from "../actions/CronAction";
const cronViewList = (
  state = { isLoad: false, data:  {} , status: false, message: "" },
  action
) => {
  switch (action.type) {
    case CRON_LOG_VIEW:
      return {
        isLoad: action.isLoad,
        data: action.data,
        status: action.status,
        message: action.message,
      };
    default:
      return state;
  }
};

const cronReducer = combineReducers({
  cronViewList
});

export default cronReducer;